import { Component } from '@angular/core';

@Component({
  selector: 'app-avaliacoes',
  standalone: false,
  
  templateUrl: './avaliacoes.component.html',
  styleUrl: './avaliacoes.component.scss'
})
export class AvaliacoesComponent {

}
